import React from "react";
import { FormatDate } from "../../../helper";
import GetTransactionStatus from "../../RecentTranactions/partials/ViewRecentTransaction/partials/GetTransactionStatus";
import LoadingSpinner from "../../Common/LoadingSpinner";
import { AccountIcon } from "../../Icons";

const SubAccountsTable = ({
  accounts,
  handleRowClick,
  activeId,
  loading,
}) => {

  return (
    <div
      className="shadow-sm md:h-[670px] h-[470px] w-full overflow-y-auto rounded-3xl hide-scrollbar table-wrapper"
    >
      {loading && accounts.length === 0 ? (
        <div className="flex items-center justify-center h-full">
          <LoadingSpinner />
        </div>
      ) : (
        <>
          <table className="w-full table">
            <thead>
              <tr>
                {["Name", "Type", "Date", "Status"].map((heading, index) => (
                  <th
                    key={index}
                    className={`table-header sticky top-0 border-b border-divider z-[1] py-3.5 pl-4 pr-3 text-left text-xs font-medium sm:pl-6 lg:pl-8`}
                  >
                    {heading}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody className="table-body">
              <tr className="h-2"></tr>
              {accounts.map((acc, index) => {
                const isActive = activeId === acc.id;

                return (
                  <React.Fragment key={acc.id}>
                    <tr
                      onClick={() => handleRowClick(acc)}
                      className={`table-row cursor-pointer ${
                        isActive ? "table-row-selected" : ""
                      }`}
                    >
                      <td className="table-row-text whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium sm:pl-6 rounded-l-3xl">
                        <div className="flex items-center">
                          <div className="w-10 h-10 rounded-full bg-background-hover flex items-center justify-center mr-3 border border-divider">
                            <AccountIcon className="w-5 h-5 text-text-secondary" />
                          </div>

                          <div className="flex flex-col">
                            <span className="font-bold text-text-primary">
                              {acc.name}
                            </span>
                            <span className="text-xs text-text-secondary">
                              {acc.email}
                            </span>
                          </div>
                        </div>
                      </td>

                      <td className="table-row-text whitespace-nowrap py-4 px-3 text-sm text-text-secondary capitalize font-medium">
                        {acc.type}
                      </td>

                      <td className="table-row-text whitespace-nowrap py-4 px-3 text-sm text-text-secondary font-medium">
                        {FormatDate(acc.created_at, "d m, yyyy")}
                      </td>

                      <td className="table-row-text whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium rounded-r-3xl">
                        <div className="flex items-center">
                          <GetTransactionStatus status={acc.status} />
                        </div>
                      </td>
                    </tr>

                    {index !== accounts.length - 1 && <tr className="h-2"></tr>}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>

          {accounts.length === 0 && !loading && (
            <div className="flex items-center justify-center h-3/4">
              <p className="text-text-secondary">No sub accounts found.</p>
            </div>
          )}

          {loading && accounts.length > 0 && (
            <div className="py-4 flex justify-center w-full">
              <LoadingSpinner />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SubAccountsTable;
